/* veyra — Header: scroll-aware transparency, hero offset var, mobile menu,
   abre o cart drawer do Dawn ao clicar na bag. */
(function () {
  function init() {
    var root = document.querySelector('veyra-header');
    if (!root) return;
    var ann = root.querySelector('[data-ann]');
    var sticky = root.querySelector('.veyra-header__sticky');

    function measure() {
      var h = (ann ? ann.offsetHeight : 0) + (sticky ? sticky.offsetHeight : 0);
      document.documentElement.style.setProperty('--veyra-hdr', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);

    function onScroll() {
      if (window.scrollY > 48) root.classList.add('is-scrolled');
      else root.classList.remove('is-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = root.querySelector('[data-menu-toggle]');
    var nav = root.querySelector('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var willOpen = nav.hasAttribute('hidden');
        if (willOpen) nav.removeAttribute('hidden');
        else nav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', String(willOpen));
        var mi = toggle.querySelector('.veyra-icon-menu');
        var ci = toggle.querySelector('.veyra-icon-close');
        if (mi) mi.hidden = willOpen;
        if (ci) ci.hidden = !willOpen;
        measure();
      });
    }

    var bag = root.querySelector('[data-cart-toggle]');
    if (bag) {
      bag.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          drawer.open(bag);
        }
      });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
